<script>
export default {
  name: 'Spinner'
}
</script>

<template>
  <div class="loader"></div>
</template>

<style scoped lang="scss">
.loader {
  border: 2px solid #DDDDDD;
  border-radius: 50%;
  border-top: 2px solid #171717;
  border-right: 2px solid #171717;
  width: 14px;
  height: 14px;
  -webkit-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
  margin: auto;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>
